import "@emotion/react";
import { j as jr } from "./jsx-runtime-721af1ab.js";
import { c as fr, g as un } from "./lodash-3345fe65.js";
import ft, { createContext as pn, useContext as fn, forwardRef as hn } from "react";
import ht from "@emotion/styled";
var _t = pn({});
_t.displayName = "ColorModeContext";
function gn() {
  const r = fn(_t);
  if (r === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return r;
}
var Oa = (...r) => r.filter(Boolean).join(" ");
function bn() {
  return process.env.NODE_ENV !== "production";
}
function q(r) {
  const e = typeof r;
  return r != null && (e === "object" || e === "function") && !Array.isArray(r);
}
var Aa = (r) => {
  const { condition: e, message: i } = r;
  e && bn() && console.warn(i);
};
function U(r, ...e) {
  return mn(r) ? r(...e) : r;
}
var mn = (r) => typeof r == "function", Pa = (r) => r ? "" : void 0, Wa = (r) => r ? !0 : void 0;
function La(...r) {
  return function(i) {
    r.some((s) => (s == null || s(i), i == null ? void 0 : i.defaultPrevented));
  };
}
function ja(...r) {
  return function(i) {
    r.forEach((s) => {
      s == null || s(i);
    });
  };
}
var br = { exports: {} };
br.exports;
(function(r, e) {
  var i = 200, s = "__lodash_hash_undefined__", d = 800, c = 16, p = 9007199254740991, u = "[object Arguments]", m = "[object Array]", f = "[object AsyncFunction]", k = "[object Boolean]", z = "[object Date]", y = "[object Error]", w = "[object Function]", A = "[object GeneratorFunction]", $ = "[object Map]", B = "[object Number]", C = "[object Null]", I = "[object Object]", M = "[object Proxy]", $t = "[object RegExp]", zt = "[object Set]", Ot = "[object String]", At = "[object Undefined]", Pt = "[object WeakMap]", Wt = "[object ArrayBuffer]", Lt = "[object DataView]", jt = "[object Float32Array]", Mt = "[object Float64Array]", Ft = "[object Int8Array]", Dt = "[object Int16Array]", Nt = "[object Int32Array]", Gt = "[object Uint8Array]", Ht = "[object Uint8ClampedArray]", Vt = "[object Uint16Array]", Xt = "[object Uint32Array]", Yt = /[\\^$.*+?()[\]{}|]/g, Ut = /^\[object .+?Constructor\]$/, qt = /^(?:0|[1-9]\d*)$/, _ = {};
  _[jt] = _[Mt] = _[Ft] = _[Dt] = _[Nt] = _[Gt] = _[Ht] = _[Vt] = _[Xt] = !0, _[u] = _[m] = _[Wt] = _[k] = _[Lt] = _[z] = _[y] = _[w] = _[$] = _[B] = _[I] = _[$t] = _[zt] = _[Ot] = _[Pt] = !1;
  var Gr = typeof fr == "object" && fr && fr.Object === Object && fr, Kt = typeof self == "object" && self && self.Object === Object && self, J = Gr || Kt || Function("return this")(), Hr = e && !e.nodeType && e, Q = Hr && !0 && r && !r.nodeType && r, Vr = Q && Q.exports === Hr, yr = Vr && Gr.process, Xr = function() {
    try {
      var t = Q && Q.require && Q.require("util").types;
      return t || yr && yr.binding && yr.binding("util");
    } catch {
    }
  }(), Yr = Xr && Xr.isTypedArray;
  function Zt(t, n, o) {
    switch (o.length) {
      case 0:
        return t.call(n);
      case 1:
        return t.call(n, o[0]);
      case 2:
        return t.call(n, o[0], o[1]);
      case 3:
        return t.call(n, o[0], o[1], o[2]);
    }
    return t.apply(n, o);
  }
  function Jt(t, n) {
    for (var o = -1, l = Array(t); ++o < t; )
      l[o] = n(o);
    return l;
  }
  function Qt(t) {
    return function(n) {
      return t(n);
    };
  }
  function re(t, n) {
    return t == null ? void 0 : t[n];
  }
  function te(t, n) {
    return function(o) {
      return t(n(o));
    };
  }
  var ee = Array.prototype, ne = Function.prototype, or = Object.prototype, Sr = J["__core-js_shared__"], ir = ne.toString, F = or.hasOwnProperty, Ur = function() {
    var t = /[^.]+$/.exec(Sr && Sr.keys && Sr.keys.IE_PROTO || "");
    return t ? "Symbol(src)_1." + t : "";
  }(), qr = or.toString, ae = ir.call(Object), oe = RegExp(
    "^" + ir.call(F).replace(Yt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), sr = Vr ? J.Buffer : void 0, Kr = J.Symbol, Zr = J.Uint8Array, Jr = sr ? sr.allocUnsafe : void 0, Qr = te(Object.getPrototypeOf, Object), rt = Object.create, ie = or.propertyIsEnumerable, se = ee.splice, V = Kr ? Kr.toStringTag : void 0, dr = function() {
    try {
      var t = Tr(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch {
    }
  }(), de = sr ? sr.isBuffer : void 0, tt = Math.max, le = Date.now, et = Tr(J, "Map"), rr = Tr(Object, "create"), ce = function() {
    function t() {
    }
    return function(n) {
      if (!Y(n))
        return {};
      if (rt)
        return rt(n);
      t.prototype = n;
      var o = new t();
      return t.prototype = void 0, o;
    };
  }();
  function X(t) {
    var n = -1, o = t == null ? 0 : t.length;
    for (this.clear(); ++n < o; ) {
      var l = t[n];
      this.set(l[0], l[1]);
    }
  }
  function ue() {
    this.__data__ = rr ? rr(null) : {}, this.size = 0;
  }
  function pe(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  function fe(t) {
    var n = this.__data__;
    if (rr) {
      var o = n[t];
      return o === s ? void 0 : o;
    }
    return F.call(n, t) ? n[t] : void 0;
  }
  function he(t) {
    var n = this.__data__;
    return rr ? n[t] !== void 0 : F.call(n, t);
  }
  function ge(t, n) {
    var o = this.__data__;
    return this.size += this.has(t) ? 0 : 1, o[t] = rr && n === void 0 ? s : n, this;
  }
  X.prototype.clear = ue, X.prototype.delete = pe, X.prototype.get = fe, X.prototype.has = he, X.prototype.set = ge;
  function D(t) {
    var n = -1, o = t == null ? 0 : t.length;
    for (this.clear(); ++n < o; ) {
      var l = t[n];
      this.set(l[0], l[1]);
    }
  }
  function be() {
    this.__data__ = [], this.size = 0;
  }
  function me(t) {
    var n = this.__data__, o = lr(n, t);
    if (o < 0)
      return !1;
    var l = n.length - 1;
    return o == l ? n.pop() : se.call(n, o, 1), --this.size, !0;
  }
  function ve(t) {
    var n = this.__data__, o = lr(n, t);
    return o < 0 ? void 0 : n[o][1];
  }
  function ye(t) {
    return lr(this.__data__, t) > -1;
  }
  function Se(t, n) {
    var o = this.__data__, l = lr(o, t);
    return l < 0 ? (++this.size, o.push([t, n])) : o[l][1] = n, this;
  }
  D.prototype.clear = be, D.prototype.delete = me, D.prototype.get = ve, D.prototype.has = ye, D.prototype.set = Se;
  function K(t) {
    var n = -1, o = t == null ? 0 : t.length;
    for (this.clear(); ++n < o; ) {
      var l = t[n];
      this.set(l[0], l[1]);
    }
  }
  function ke() {
    this.size = 0, this.__data__ = {
      hash: new X(),
      map: new (et || D)(),
      string: new X()
    };
  }
  function _e(t) {
    var n = ur(this, t).delete(t);
    return this.size -= n ? 1 : 0, n;
  }
  function Te(t) {
    return ur(this, t).get(t);
  }
  function xe(t) {
    return ur(this, t).has(t);
  }
  function Re(t, n) {
    var o = ur(this, t), l = o.size;
    return o.set(t, n), this.size += o.size == l ? 0 : 1, this;
  }
  K.prototype.clear = ke, K.prototype.delete = _e, K.prototype.get = Te, K.prototype.has = xe, K.prototype.set = Re;
  function Z(t) {
    var n = this.__data__ = new D(t);
    this.size = n.size;
  }
  function we() {
    this.__data__ = new D(), this.size = 0;
  }
  function Be(t) {
    var n = this.__data__, o = n.delete(t);
    return this.size = n.size, o;
  }
  function Ce(t) {
    return this.__data__.get(t);
  }
  function Ie(t) {
    return this.__data__.has(t);
  }
  function Ee(t, n) {
    var o = this.__data__;
    if (o instanceof D) {
      var l = o.__data__;
      if (!et || l.length < i - 1)
        return l.push([t, n]), this.size = ++o.size, this;
      o = this.__data__ = new K(l);
    }
    return o.set(t, n), this.size = o.size, this;
  }
  Z.prototype.clear = we, Z.prototype.delete = Be, Z.prototype.get = Ce, Z.prototype.has = Ie, Z.prototype.set = Ee;
  function $e(t, n) {
    var o = wr(t), l = !o && Rr(t), b = !o && !l && st(t), S = !o && !l && !b && lt(t), x = o || l || b || S, h = x ? Jt(t.length, String) : [], R = h.length;
    for (var P in t)
      (n || F.call(t, P)) && !(x && // Safari 9 has enumerable `arguments.length` in strict mode.
      (P == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      b && (P == "offset" || P == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      S && (P == "buffer" || P == "byteLength" || P == "byteOffset") || // Skip index properties.
      ot(P, R))) && h.push(P);
    return h;
  }
  function kr(t, n, o) {
    (o !== void 0 && !pr(t[n], o) || o === void 0 && !(n in t)) && _r(t, n, o);
  }
  function ze(t, n, o) {
    var l = t[n];
    (!(F.call(t, n) && pr(l, o)) || o === void 0 && !(n in t)) && _r(t, n, o);
  }
  function lr(t, n) {
    for (var o = t.length; o--; )
      if (pr(t[o][0], n))
        return o;
    return -1;
  }
  function _r(t, n, o) {
    n == "__proto__" && dr ? dr(t, n, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : t[n] = o;
  }
  var Oe = Xe();
  function cr(t) {
    return t == null ? t === void 0 ? At : C : V && V in Object(t) ? Ye(t) : Qe(t);
  }
  function nt(t) {
    return tr(t) && cr(t) == u;
  }
  function Ae(t) {
    if (!Y(t) || Ze(t))
      return !1;
    var n = Cr(t) ? oe : Ut;
    return n.test(nn(t));
  }
  function Pe(t) {
    return tr(t) && dt(t.length) && !!_[cr(t)];
  }
  function We(t) {
    if (!Y(t))
      return Je(t);
    var n = it(t), o = [];
    for (var l in t)
      l == "constructor" && (n || !F.call(t, l)) || o.push(l);
    return o;
  }
  function at(t, n, o, l, b) {
    t !== n && Oe(n, function(S, x) {
      if (b || (b = new Z()), Y(S))
        Le(t, n, x, o, at, l, b);
      else {
        var h = l ? l(xr(t, x), S, x + "", t, n, b) : void 0;
        h === void 0 && (h = S), kr(t, x, h);
      }
    }, ct);
  }
  function Le(t, n, o, l, b, S, x) {
    var h = xr(t, o), R = xr(n, o), P = x.get(R);
    if (P) {
      kr(t, o, P);
      return;
    }
    var O = S ? S(h, R, o + "", t, n, x) : void 0, er = O === void 0;
    if (er) {
      var Ir = wr(R), Er = !Ir && st(R), pt = !Ir && !Er && lt(R);
      O = R, Ir || Er || pt ? wr(h) ? O = h : an(h) ? O = Ge(h) : Er ? (er = !1, O = Fe(R, !0)) : pt ? (er = !1, O = Ne(R, !0)) : O = [] : on(R) || Rr(R) ? (O = h, Rr(h) ? O = sn(h) : (!Y(h) || Cr(h)) && (O = Ue(R))) : er = !1;
    }
    er && (x.set(R, O), b(O, R, l, S, x), x.delete(R)), kr(t, o, O);
  }
  function je(t, n) {
    return tn(rn(t, n, ut), t + "");
  }
  var Me = dr ? function(t, n) {
    return dr(t, "toString", {
      configurable: !0,
      enumerable: !1,
      value: ln(n),
      writable: !0
    });
  } : ut;
  function Fe(t, n) {
    if (n)
      return t.slice();
    var o = t.length, l = Jr ? Jr(o) : new t.constructor(o);
    return t.copy(l), l;
  }
  function De(t) {
    var n = new t.constructor(t.byteLength);
    return new Zr(n).set(new Zr(t)), n;
  }
  function Ne(t, n) {
    var o = n ? De(t.buffer) : t.buffer;
    return new t.constructor(o, t.byteOffset, t.length);
  }
  function Ge(t, n) {
    var o = -1, l = t.length;
    for (n || (n = Array(l)); ++o < l; )
      n[o] = t[o];
    return n;
  }
  function He(t, n, o, l) {
    var b = !o;
    o || (o = {});
    for (var S = -1, x = n.length; ++S < x; ) {
      var h = n[S], R = l ? l(o[h], t[h], h, o, t) : void 0;
      R === void 0 && (R = t[h]), b ? _r(o, h, R) : ze(o, h, R);
    }
    return o;
  }
  function Ve(t) {
    return je(function(n, o) {
      var l = -1, b = o.length, S = b > 1 ? o[b - 1] : void 0, x = b > 2 ? o[2] : void 0;
      for (S = t.length > 3 && typeof S == "function" ? (b--, S) : void 0, x && qe(o[0], o[1], x) && (S = b < 3 ? void 0 : S, b = 1), n = Object(n); ++l < b; ) {
        var h = o[l];
        h && t(n, h, l, S);
      }
      return n;
    });
  }
  function Xe(t) {
    return function(n, o, l) {
      for (var b = -1, S = Object(n), x = l(n), h = x.length; h--; ) {
        var R = x[t ? h : ++b];
        if (o(S[R], R, S) === !1)
          break;
      }
      return n;
    };
  }
  function ur(t, n) {
    var o = t.__data__;
    return Ke(n) ? o[typeof n == "string" ? "string" : "hash"] : o.map;
  }
  function Tr(t, n) {
    var o = re(t, n);
    return Ae(o) ? o : void 0;
  }
  function Ye(t) {
    var n = F.call(t, V), o = t[V];
    try {
      t[V] = void 0;
      var l = !0;
    } catch {
    }
    var b = qr.call(t);
    return l && (n ? t[V] = o : delete t[V]), b;
  }
  function Ue(t) {
    return typeof t.constructor == "function" && !it(t) ? ce(Qr(t)) : {};
  }
  function ot(t, n) {
    var o = typeof t;
    return n = n ?? p, !!n && (o == "number" || o != "symbol" && qt.test(t)) && t > -1 && t % 1 == 0 && t < n;
  }
  function qe(t, n, o) {
    if (!Y(o))
      return !1;
    var l = typeof n;
    return (l == "number" ? Br(o) && ot(n, o.length) : l == "string" && n in o) ? pr(o[n], t) : !1;
  }
  function Ke(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  function Ze(t) {
    return !!Ur && Ur in t;
  }
  function it(t) {
    var n = t && t.constructor, o = typeof n == "function" && n.prototype || or;
    return t === o;
  }
  function Je(t) {
    var n = [];
    if (t != null)
      for (var o in Object(t))
        n.push(o);
    return n;
  }
  function Qe(t) {
    return qr.call(t);
  }
  function rn(t, n, o) {
    return n = tt(n === void 0 ? t.length - 1 : n, 0), function() {
      for (var l = arguments, b = -1, S = tt(l.length - n, 0), x = Array(S); ++b < S; )
        x[b] = l[n + b];
      b = -1;
      for (var h = Array(n + 1); ++b < n; )
        h[b] = l[b];
      return h[n] = o(x), Zt(t, this, h);
    };
  }
  function xr(t, n) {
    if (!(n === "constructor" && typeof t[n] == "function") && n != "__proto__")
      return t[n];
  }
  var tn = en(Me);
  function en(t) {
    var n = 0, o = 0;
    return function() {
      var l = le(), b = c - (l - o);
      if (o = l, b > 0) {
        if (++n >= d)
          return arguments[0];
      } else
        n = 0;
      return t.apply(void 0, arguments);
    };
  }
  function nn(t) {
    if (t != null) {
      try {
        return ir.call(t);
      } catch {
      }
      try {
        return t + "";
      } catch {
      }
    }
    return "";
  }
  function pr(t, n) {
    return t === n || t !== t && n !== n;
  }
  var Rr = nt(function() {
    return arguments;
  }()) ? nt : function(t) {
    return tr(t) && F.call(t, "callee") && !ie.call(t, "callee");
  }, wr = Array.isArray;
  function Br(t) {
    return t != null && dt(t.length) && !Cr(t);
  }
  function an(t) {
    return tr(t) && Br(t);
  }
  var st = de || cn;
  function Cr(t) {
    if (!Y(t))
      return !1;
    var n = cr(t);
    return n == w || n == A || n == f || n == M;
  }
  function dt(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= p;
  }
  function Y(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  function tr(t) {
    return t != null && typeof t == "object";
  }
  function on(t) {
    if (!tr(t) || cr(t) != I)
      return !1;
    var n = Qr(t);
    if (n === null)
      return !0;
    var o = F.call(n, "constructor") && n.constructor;
    return typeof o == "function" && o instanceof o && ir.call(o) == ae;
  }
  var lt = Yr ? Qt(Yr) : Pe;
  function sn(t) {
    return He(t, ct(t));
  }
  function ct(t) {
    return Br(t) ? $e(t, !0) : We(t);
  }
  var dn = Ve(function(t, n, o, l) {
    at(t, n, o, l);
  });
  function ln(t) {
    return function() {
      return t;
    };
  }
  function ut(t) {
    return t;
  }
  function cn() {
    return !1;
  }
  r.exports = dn;
})(br, br.exports);
var vn = br.exports;
const H = /* @__PURE__ */ un(vn);
var yn = (r) => /!(important)?$/.test(r), gt = (r) => typeof r == "string" ? r.replace(/!(important)?$/, "").trim() : r, Sn = (r, e) => (i) => {
  const s = String(e), d = yn(s), c = gt(s), p = r ? `${r}.${c}` : c;
  let u = q(i.__cssMap) && p in i.__cssMap ? i.__cssMap[p].varRef : e;
  return u = gt(u), d ? `${u} !important` : u;
};
function Mr(r) {
  const { scale: e, transform: i, compose: s } = r;
  return (c, p) => {
    var u;
    const m = Sn(e, c)(p);
    let f = (u = i == null ? void 0 : i(m, p)) != null ? u : m;
    return s && (f = s(f, p)), f;
  };
}
var hr = (...r) => (e) => r.reduce((i, s) => s(i), e);
function W(r, e) {
  return (i) => {
    const s = { property: i, scale: r };
    return s.transform = Mr({
      scale: r,
      transform: e
    }), s;
  };
}
var kn = ({ rtl: r, ltr: e }) => (i) => i.direction === "rtl" ? r : e;
function _n(r) {
  const { property: e, scale: i, transform: s } = r;
  return {
    scale: i,
    property: kn(e),
    transform: i ? Mr({
      scale: i,
      compose: s
    }) : s
  };
}
var Tt = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function Tn() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ...Tt
  ].join(" ");
}
function xn() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ...Tt
  ].join(" ");
}
var Rn = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
}, wn = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function Bn(r) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": r,
    boxShadow: [
      "var(--chakra-ring-offset-shadow)",
      "var(--chakra-ring-shadow)",
      "var(--chakra-shadow, 0 0 #0000)"
    ].join(", ")
  };
}
var Cn = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, Or = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, In = new Set(Object.values(Or)), Ar = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]), En = (r) => r.trim();
function $n(r, e) {
  if (r == null || Ar.has(r))
    return r;
  if (!(Pr(r) || Ar.has(r)))
    return `url('${r}')`;
  const d = /(^[a-z-A-Z]+)\((.*)\)/g.exec(r), c = d == null ? void 0 : d[1], p = d == null ? void 0 : d[2];
  if (!c || !p)
    return r;
  const u = c.includes("-gradient") ? c : `${c}-gradient`, [m, ...f] = p.split(",").map(En).filter(Boolean);
  if ((f == null ? void 0 : f.length) === 0)
    return r;
  const k = m in Or ? Or[m] : m;
  f.unshift(k);
  const z = f.map((y) => {
    if (In.has(y))
      return y;
    const w = y.indexOf(" "), [A, $] = w !== -1 ? [y.substr(0, w), y.substr(w + 1)] : [y], B = Pr($) ? $ : $ && $.split(" "), C = `colors.${A}`, I = C in e.__cssMap ? e.__cssMap[C].varRef : A;
    return B ? [
      I,
      ...Array.isArray(B) ? B : [B]
    ].join(" ") : I;
  });
  return `${u}(${z.join(", ")})`;
}
var Pr = (r) => typeof r == "string" && r.includes("(") && r.includes(")"), zn = (r, e) => $n(r, e ?? {});
function On(r) {
  return /^var\(--.+\)$/.test(r);
}
var An = (r) => {
  const e = parseFloat(r.toString()), i = r.toString().replace(String(e), "");
  return { unitless: !i, value: e, unit: i };
}, j = (r) => (e) => `${r}(${e})`, g = {
  filter(r) {
    return r !== "auto" ? r : Rn;
  },
  backdropFilter(r) {
    return r !== "auto" ? r : wn;
  },
  ring(r) {
    return Bn(g.px(r));
  },
  bgClip(r) {
    return r === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: r };
  },
  transform(r) {
    return r === "auto" ? Tn() : r === "auto-gpu" ? xn() : r;
  },
  vh(r) {
    return r === "$100vh" ? "var(--chakra-vh)" : r;
  },
  px(r) {
    if (r == null)
      return r;
    const { unitless: e } = An(r);
    return e || typeof r == "number" ? `${r}px` : r;
  },
  fraction(r) {
    return typeof r != "number" || r > 1 ? r : `${r * 100}%`;
  },
  float(r, e) {
    const i = { left: "right", right: "left" };
    return e.direction === "rtl" ? i[r] : r;
  },
  degree(r) {
    if (On(r) || r == null)
      return r;
    const e = typeof r == "string" && !r.endsWith("deg");
    return typeof r == "number" || e ? `${r}deg` : r;
  },
  gradient: zn,
  blur: j("blur"),
  opacity: j("opacity"),
  brightness: j("brightness"),
  contrast: j("contrast"),
  dropShadow: j("drop-shadow"),
  grayscale: j("grayscale"),
  hueRotate: (r) => j("hue-rotate")(g.degree(r)),
  invert: j("invert"),
  saturate: j("saturate"),
  sepia: j("sepia"),
  bgImage(r) {
    return r == null || Pr(r) || Ar.has(r) ? r : `url(${r})`;
  },
  outline(r) {
    const e = String(r) === "0" || String(r) === "none";
    return r !== null && e ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: r };
  },
  flexDirection(r) {
    var e;
    const { space: i, divide: s } = (e = Cn[r]) != null ? e : {}, d = { flexDirection: r };
    return i && (d[i] = 1), s && (d[s] = 1), d;
  }
}, a = {
  borderWidths: W("borderWidths"),
  borderStyles: W("borderStyles"),
  colors: W("colors"),
  borders: W("borders"),
  gradients: W("gradients", g.gradient),
  radii: W("radii", g.px),
  space: W("space", hr(g.vh, g.px)),
  spaceT: W("space", hr(g.vh, g.px)),
  degreeT(r) {
    return { property: r, transform: g.degree };
  },
  prop(r, e, i) {
    return {
      property: r,
      scale: e,
      ...e && {
        transform: Mr({ scale: e, transform: i })
      }
    };
  },
  propT(r, e) {
    return { property: r, transform: e };
  },
  sizes: W("sizes", hr(g.vh, g.px)),
  sizesT: W("sizes", hr(g.vh, g.fraction)),
  shadows: W("shadows"),
  logical: _n,
  blur: W("blur", g.blur)
}, gr = {
  background: a.colors("background"),
  backgroundColor: a.colors("backgroundColor"),
  backgroundImage: a.gradients("backgroundImage"),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: { transform: g.bgClip },
  bgSize: a.prop("backgroundSize"),
  bgPosition: a.prop("backgroundPosition"),
  bg: a.colors("background"),
  bgColor: a.colors("backgroundColor"),
  bgPos: a.prop("backgroundPosition"),
  bgRepeat: a.prop("backgroundRepeat"),
  bgAttachment: a.prop("backgroundAttachment"),
  bgGradient: a.gradients("backgroundImage"),
  bgClip: { transform: g.bgClip }
};
Object.assign(gr, {
  bgImage: gr.backgroundImage,
  bgImg: gr.backgroundImage
});
var v = {
  border: a.borders("border"),
  borderWidth: a.borderWidths("borderWidth"),
  borderStyle: a.borderStyles("borderStyle"),
  borderColor: a.colors("borderColor"),
  borderRadius: a.radii("borderRadius"),
  borderTop: a.borders("borderTop"),
  borderBlockStart: a.borders("borderBlockStart"),
  borderTopLeftRadius: a.radii("borderTopLeftRadius"),
  borderStartStartRadius: a.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: a.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: a.radii("borderTopRightRadius"),
  borderStartEndRadius: a.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: a.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: a.borders("borderRight"),
  borderInlineEnd: a.borders("borderInlineEnd"),
  borderBottom: a.borders("borderBottom"),
  borderBlockEnd: a.borders("borderBlockEnd"),
  borderBottomLeftRadius: a.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: a.radii("borderBottomRightRadius"),
  borderLeft: a.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: a.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: a.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: a.borders(["borderLeft", "borderRight"]),
  borderInline: a.borders("borderInline"),
  borderY: a.borders(["borderTop", "borderBottom"]),
  borderBlock: a.borders("borderBlock"),
  borderTopWidth: a.borderWidths("borderTopWidth"),
  borderBlockStartWidth: a.borderWidths("borderBlockStartWidth"),
  borderTopColor: a.colors("borderTopColor"),
  borderBlockStartColor: a.colors("borderBlockStartColor"),
  borderTopStyle: a.borderStyles("borderTopStyle"),
  borderBlockStartStyle: a.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: a.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: a.borderWidths("borderBlockEndWidth"),
  borderBottomColor: a.colors("borderBottomColor"),
  borderBlockEndColor: a.colors("borderBlockEndColor"),
  borderBottomStyle: a.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: a.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: a.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: a.borderWidths("borderInlineStartWidth"),
  borderLeftColor: a.colors("borderLeftColor"),
  borderInlineStartColor: a.colors("borderInlineStartColor"),
  borderLeftStyle: a.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: a.borderStyles("borderInlineStartStyle"),
  borderRightWidth: a.borderWidths("borderRightWidth"),
  borderInlineEndWidth: a.borderWidths("borderInlineEndWidth"),
  borderRightColor: a.colors("borderRightColor"),
  borderInlineEndColor: a.colors("borderInlineEndColor"),
  borderRightStyle: a.borderStyles("borderRightStyle"),
  borderInlineEndStyle: a.borderStyles("borderInlineEndStyle"),
  borderTopRadius: a.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: a.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: a.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: a.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(v, {
  rounded: v.borderRadius,
  roundedTop: v.borderTopRadius,
  roundedTopLeft: v.borderTopLeftRadius,
  roundedTopRight: v.borderTopRightRadius,
  roundedTopStart: v.borderStartStartRadius,
  roundedTopEnd: v.borderStartEndRadius,
  roundedBottom: v.borderBottomRadius,
  roundedBottomLeft: v.borderBottomLeftRadius,
  roundedBottomRight: v.borderBottomRightRadius,
  roundedBottomStart: v.borderEndStartRadius,
  roundedBottomEnd: v.borderEndEndRadius,
  roundedLeft: v.borderLeftRadius,
  roundedRight: v.borderRightRadius,
  roundedStart: v.borderInlineStartRadius,
  roundedEnd: v.borderInlineEndRadius,
  borderStart: v.borderInlineStart,
  borderEnd: v.borderInlineEnd,
  borderTopStartRadius: v.borderStartStartRadius,
  borderTopEndRadius: v.borderStartEndRadius,
  borderBottomStartRadius: v.borderEndStartRadius,
  borderBottomEndRadius: v.borderEndEndRadius,
  borderStartRadius: v.borderInlineStartRadius,
  borderEndRadius: v.borderInlineEndRadius,
  borderStartWidth: v.borderInlineStartWidth,
  borderEndWidth: v.borderInlineEndWidth,
  borderStartColor: v.borderInlineStartColor,
  borderEndColor: v.borderInlineEndColor,
  borderStartStyle: v.borderInlineStartStyle,
  borderEndStyle: v.borderInlineEndStyle
});
var Pn = {
  color: a.colors("color"),
  textColor: a.colors("color"),
  fill: a.colors("fill"),
  stroke: a.colors("stroke")
}, Wr = {
  boxShadow: a.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: a.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: a.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(Wr, {
  shadow: Wr.boxShadow
});
var Wn = {
  filter: { transform: g.filter },
  blur: a.blur("--chakra-blur"),
  brightness: a.propT("--chakra-brightness", g.brightness),
  contrast: a.propT("--chakra-contrast", g.contrast),
  hueRotate: a.propT("--chakra-hue-rotate", g.hueRotate),
  invert: a.propT("--chakra-invert", g.invert),
  saturate: a.propT("--chakra-saturate", g.saturate),
  dropShadow: a.propT("--chakra-drop-shadow", g.dropShadow),
  backdropFilter: { transform: g.backdropFilter },
  backdropBlur: a.blur("--chakra-backdrop-blur"),
  backdropBrightness: a.propT(
    "--chakra-backdrop-brightness",
    g.brightness
  ),
  backdropContrast: a.propT("--chakra-backdrop-contrast", g.contrast),
  backdropHueRotate: a.propT(
    "--chakra-backdrop-hue-rotate",
    g.hueRotate
  ),
  backdropInvert: a.propT("--chakra-backdrop-invert", g.invert),
  backdropSaturate: a.propT("--chakra-backdrop-saturate", g.saturate)
}, mr = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: { transform: g.flexDirection },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: a.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: a.space("gap"),
  rowGap: a.space("rowGap"),
  columnGap: a.space("columnGap")
};
Object.assign(mr, {
  flexDir: mr.flexDirection
});
var xt = {
  gridGap: a.space("gridGap"),
  gridColumnGap: a.space("gridColumnGap"),
  gridRowGap: a.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, Ln = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: { transform: g.outline },
  outlineOffset: !0,
  outlineColor: a.colors("outlineColor")
}, L = {
  width: a.sizesT("width"),
  inlineSize: a.sizesT("inlineSize"),
  height: a.sizes("height"),
  blockSize: a.sizes("blockSize"),
  boxSize: a.sizes(["width", "height"]),
  minWidth: a.sizes("minWidth"),
  minInlineSize: a.sizes("minInlineSize"),
  minHeight: a.sizes("minHeight"),
  minBlockSize: a.sizes("minBlockSize"),
  maxWidth: a.sizes("maxWidth"),
  maxInlineSize: a.sizes("maxInlineSize"),
  maxHeight: a.sizes("maxHeight"),
  maxBlockSize: a.sizes("maxBlockSize"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  aspectRatio: !0,
  hideFrom: {
    scale: "breakpoints",
    transform: (r, e) => {
      var i, s, d;
      return { [`@media screen and (min-width: ${(d = (s = (i = e.__breakpoints) == null ? void 0 : i.get(r)) == null ? void 0 : s.minW) != null ? d : r})`]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (r, e) => {
      var i, s, d;
      return { [`@media screen and (max-width: ${(d = (s = (i = e.__breakpoints) == null ? void 0 : i.get(r)) == null ? void 0 : s._minW) != null ? d : r})`]: { display: "none" } };
    }
  },
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: a.propT("float", g.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(L, {
  w: L.width,
  h: L.height,
  minW: L.minWidth,
  maxW: L.maxWidth,
  minH: L.minHeight,
  maxH: L.maxHeight,
  overscroll: L.overscrollBehavior,
  overscrollX: L.overscrollBehaviorX,
  overscrollY: L.overscrollBehaviorY
});
var jn = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: a.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: a.prop("listStyleImage")
};
function Mn(r, e, i, s) {
  const d = typeof e == "string" ? e.split(".") : [e];
  for (s = 0; s < d.length && r; s += 1)
    r = r[d[s]];
  return r === void 0 ? i : r;
}
var Fn = (r) => {
  const e = /* @__PURE__ */ new WeakMap();
  return (s, d, c, p) => {
    if (typeof s > "u")
      return r(s, d, c);
    e.has(s) || e.set(s, /* @__PURE__ */ new Map());
    const u = e.get(s);
    if (u.has(d))
      return u.get(d);
    const m = r(s, d, c, p);
    return u.set(d, m), m;
  };
}, Dn = Fn(Mn), Nn = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, Gn = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, $r = (r, e, i) => {
  const s = {}, d = Dn(r, e, {});
  for (const c in d)
    c in i && i[c] != null || (s[c] = d[c]);
  return s;
}, Hn = {
  srOnly: {
    transform(r) {
      return r === !0 ? Nn : r === "focusable" ? Gn : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: (r, e, i) => $r(e, `layerStyles.${r}`, i)
  },
  textStyle: {
    processResult: !0,
    transform: (r, e, i) => $r(e, `textStyles.${r}`, i)
  },
  apply: {
    processResult: !0,
    transform: (r, e, i) => $r(e, r, i)
  }
}, ar = {
  position: !0,
  pos: a.prop("position"),
  zIndex: a.prop("zIndex", "zIndices"),
  inset: a.spaceT("inset"),
  insetX: a.spaceT(["left", "right"]),
  insetInline: a.spaceT("insetInline"),
  insetY: a.spaceT(["top", "bottom"]),
  insetBlock: a.spaceT("insetBlock"),
  top: a.spaceT("top"),
  insetBlockStart: a.spaceT("insetBlockStart"),
  bottom: a.spaceT("bottom"),
  insetBlockEnd: a.spaceT("insetBlockEnd"),
  left: a.spaceT("left"),
  insetInlineStart: a.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: a.spaceT("right"),
  insetInlineEnd: a.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(ar, {
  insetStart: ar.insetInlineStart,
  insetEnd: ar.insetInlineEnd
});
var Vn = {
  ring: { transform: g.ring },
  ringColor: a.colors("--chakra-ring-color"),
  ringOffset: a.prop("--chakra-ring-offset-width"),
  ringOffsetColor: a.colors("--chakra-ring-offset-color"),
  ringInset: a.prop("--chakra-ring-inset")
}, T = {
  margin: a.spaceT("margin"),
  marginTop: a.spaceT("marginTop"),
  marginBlockStart: a.spaceT("marginBlockStart"),
  marginRight: a.spaceT("marginRight"),
  marginInlineEnd: a.spaceT("marginInlineEnd"),
  marginBottom: a.spaceT("marginBottom"),
  marginBlockEnd: a.spaceT("marginBlockEnd"),
  marginLeft: a.spaceT("marginLeft"),
  marginInlineStart: a.spaceT("marginInlineStart"),
  marginX: a.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: a.spaceT("marginInline"),
  marginY: a.spaceT(["marginTop", "marginBottom"]),
  marginBlock: a.spaceT("marginBlock"),
  padding: a.space("padding"),
  paddingTop: a.space("paddingTop"),
  paddingBlockStart: a.space("paddingBlockStart"),
  paddingRight: a.space("paddingRight"),
  paddingBottom: a.space("paddingBottom"),
  paddingBlockEnd: a.space("paddingBlockEnd"),
  paddingLeft: a.space("paddingLeft"),
  paddingInlineStart: a.space("paddingInlineStart"),
  paddingInlineEnd: a.space("paddingInlineEnd"),
  paddingX: a.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: a.space("paddingInline"),
  paddingY: a.space(["paddingTop", "paddingBottom"]),
  paddingBlock: a.space("paddingBlock")
};
Object.assign(T, {
  m: T.margin,
  mt: T.marginTop,
  mr: T.marginRight,
  me: T.marginInlineEnd,
  marginEnd: T.marginInlineEnd,
  mb: T.marginBottom,
  ml: T.marginLeft,
  ms: T.marginInlineStart,
  marginStart: T.marginInlineStart,
  mx: T.marginX,
  my: T.marginY,
  p: T.padding,
  pt: T.paddingTop,
  py: T.paddingY,
  px: T.paddingX,
  pb: T.paddingBottom,
  pl: T.paddingLeft,
  ps: T.paddingInlineStart,
  paddingStart: T.paddingInlineStart,
  pr: T.paddingRight,
  pe: T.paddingInlineEnd,
  paddingEnd: T.paddingInlineEnd
});
var Xn = {
  textDecorationColor: a.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: { property: "textDecoration" },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: a.shadows("textShadow")
}, Yn = {
  clipPath: !0,
  transform: a.propT("transform", g.transform),
  transformOrigin: !0,
  translateX: a.spaceT("--chakra-translate-x"),
  translateY: a.spaceT("--chakra-translate-y"),
  skewX: a.degreeT("--chakra-skew-x"),
  skewY: a.degreeT("--chakra-skew-y"),
  scaleX: a.prop("--chakra-scale-x"),
  scaleY: a.prop("--chakra-scale-y"),
  scale: a.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: a.degreeT("--chakra-rotate")
}, Un = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: a.prop("transitionDuration", "transition.duration"),
  transitionProperty: a.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: a.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
}, qn = {
  fontFamily: a.prop("fontFamily", "fonts"),
  fontSize: a.prop("fontSize", "fontSizes", g.px),
  fontWeight: a.prop("fontWeight", "fontWeights"),
  lineHeight: a.prop("lineHeight", "lineHeights"),
  letterSpacing: a.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  textIndent: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  isTruncated: {
    transform(r) {
      if (r === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
}, Kn = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: a.spaceT("scrollMargin"),
  scrollMarginTop: a.spaceT("scrollMarginTop"),
  scrollMarginBottom: a.spaceT("scrollMarginBottom"),
  scrollMarginLeft: a.spaceT("scrollMarginLeft"),
  scrollMarginRight: a.spaceT("scrollMarginRight"),
  scrollMarginX: a.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: a.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: a.spaceT("scrollPadding"),
  scrollPaddingTop: a.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: a.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: a.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: a.spaceT("scrollPaddingRight"),
  scrollPaddingX: a.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: a.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function Rt(r) {
  return q(r) && r.reference ? r.reference : String(r);
}
var vr = (r, ...e) => e.map(Rt).join(` ${r} `).replace(/calc/g, ""), bt = (...r) => `calc(${vr("+", ...r)})`, mt = (...r) => `calc(${vr("-", ...r)})`, Lr = (...r) => `calc(${vr("*", ...r)})`, vt = (...r) => `calc(${vr("/", ...r)})`, yt = (r) => {
  const e = Rt(r);
  return e != null && !Number.isNaN(parseFloat(e)) ? String(e).startsWith("-") ? String(e).slice(1) : `-${e}` : Lr(e, -1);
}, nr = Object.assign(
  (r) => ({
    add: (...e) => nr(bt(r, ...e)),
    subtract: (...e) => nr(mt(r, ...e)),
    multiply: (...e) => nr(Lr(r, ...e)),
    divide: (...e) => nr(vt(r, ...e)),
    negate: () => nr(yt(r)),
    toString: () => r.toString()
  }),
  {
    add: bt,
    subtract: mt,
    multiply: Lr,
    divide: vt,
    negate: yt
  }
);
function Zn(r) {
  const e = parseFloat(r.toString()), i = r.toString().replace(String(e), "");
  return { unitless: !i, value: e, unit: i };
}
function St(r) {
  if (r == null)
    return r;
  const { unitless: e } = Zn(r);
  return e || typeof r == "number" ? `${r}px` : r;
}
function Jn(r, e) {
  const i = ["@media screen"];
  return r && i.push("and", `(min-width: ${St(r)})`), e && i.push("and", `(max-width: ${St(e)})`), i.join(" ");
}
var E = {
  hover: (r, e) => `${r}:hover ${e}, ${r}[data-hover] ${e}`,
  focus: (r, e) => `${r}:focus ${e}, ${r}[data-focus] ${e}`,
  focusVisible: (r, e) => `${r}:focus-visible ${e}`,
  focusWithin: (r, e) => `${r}:focus-within ${e}`,
  active: (r, e) => `${r}:active ${e}, ${r}[data-active] ${e}`,
  disabled: (r, e) => `${r}:disabled ${e}, ${r}[data-disabled] ${e}`,
  invalid: (r, e) => `${r}:invalid ${e}, ${r}[data-invalid] ${e}`,
  checked: (r, e) => `${r}:checked ${e}, ${r}[data-checked] ${e}`,
  indeterminate: (r, e) => `${r}:indeterminate ${e}, ${r}[aria-checked=mixed] ${e}, ${r}[data-indeterminate] ${e}`,
  readOnly: (r, e) => `${r}:read-only ${e}, ${r}[readonly] ${e}, ${r}[data-read-only] ${e}`,
  expanded: (r, e) => `${r}:read-only ${e}, ${r}[aria-expanded=true] ${e}, ${r}[data-expanded] ${e}`,
  placeholderShown: (r, e) => `${r}:placeholder-shown ${e}`
}, G = (r) => wt((e) => r(e, "&"), "[role=group]", "[data-group]", ".group"), N = (r) => wt((e) => r(e, "~ &"), "[data-peer]", ".peer"), wt = (r, ...e) => e.map(r).join(", "), Fr = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */
  _firstLetter: "&::first-letter",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: G(E.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: N(E.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: G(E.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: N(E.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: G(E.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: N(E.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: G(E.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: N(E.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: G(E.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: N(E.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: G(E.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: N(E.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: G(E.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: N(E.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: G(E.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: N(E.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: N(E.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */
  _horizontal: "&[data-orientation=horizontal]",
  /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */
  _vertical: "&[data-orientation=vertical]"
}, Qn = Object.keys(
  Fr
);
function ra(r, e = []) {
  const i = Object.assign({}, r);
  for (const s of e)
    s in i && delete i[s];
  return i;
}
var Dr = H(
  {},
  gr,
  v,
  Pn,
  mr,
  L,
  Wn,
  Vn,
  Ln,
  xt,
  Hn,
  ar,
  Wr,
  T,
  Kn,
  qn,
  Xn,
  Yn,
  jn,
  Un
);
Object.assign({}, T, L, mr, xt, ar);
var ta = [...Object.keys(Dr), ...Qn], ea = { ...Dr, ...Fr }, na = (r) => r in ea, aa = (r) => (e) => {
  if (!e.__breakpoints)
    return r;
  const { isResponsive: i, toArrayValue: s, media: d } = e.__breakpoints, c = {};
  for (const p in r) {
    let u = U(r[p], e);
    if (u == null)
      continue;
    if (u = q(u) && i(u) ? s(u) : u, !Array.isArray(u)) {
      c[p] = u;
      continue;
    }
    const m = u.slice(0, d.length).length;
    for (let f = 0; f < m; f += 1) {
      const k = d == null ? void 0 : d[f];
      if (!k) {
        c[p] = u[f];
        continue;
      }
      c[k] = c[k] || {}, u[f] != null && (c[k][p] = u[f]);
    }
  }
  return c;
};
function oa(r) {
  const e = [];
  let i = "", s = !1;
  for (let d = 0; d < r.length; d++) {
    const c = r[d];
    c === "(" ? (s = !0, i += c) : c === ")" ? (s = !1, i += c) : c === "," && !s ? (e.push(i), i = "") : i += c;
  }
  return i = i.trim(), i && e.push(i), e;
}
function ia(r) {
  return /^var\(--.+\)$/.test(r);
}
var sa = (r, e) => r.startsWith("--") && typeof e == "string" && !ia(e), da = (r, e) => {
  var i, s;
  if (e == null)
    return e;
  const d = (m) => {
    var f, k;
    return (k = (f = r.__cssMap) == null ? void 0 : f[m]) == null ? void 0 : k.varRef;
  }, c = (m) => {
    var f;
    return (f = d(m)) != null ? f : m;
  }, [p, u] = oa(e);
  return e = (s = (i = d(p)) != null ? i : c(u)) != null ? s : c(e), e;
};
function la(r) {
  const { configs: e = {}, pseudos: i = {}, theme: s } = r, d = (c, p = !1) => {
    var u, m, f;
    const k = U(c, s), z = aa(k)(s);
    let y = {};
    for (let w in z) {
      const A = z[w];
      let $ = U(A, s);
      w in i && (w = i[w]), sa(w, $) && ($ = da(s, $));
      let B = e[w];
      if (B === !0 && (B = { property: w }), q($)) {
        y[w] = (u = y[w]) != null ? u : {}, y[w] = H(
          {},
          y[w],
          d($, !0)
        );
        continue;
      }
      let C = (f = (m = B == null ? void 0 : B.transform) == null ? void 0 : m.call(B, $, s, k)) != null ? f : $;
      C = B != null && B.processResult ? d(C, !0) : C;
      const I = U(B == null ? void 0 : B.property, s);
      if (!p && (B != null && B.static)) {
        const M = U(B.static, s);
        y = H({}, y, M);
      }
      if (I && Array.isArray(I)) {
        for (const M of I)
          y[M] = C;
        continue;
      }
      if (I) {
        I === "&" && q(C) ? y = H({}, y, C) : y[I] = C;
        continue;
      }
      if (q(C)) {
        y = H({}, y, C);
        continue;
      }
      y[w] = C;
    }
    return y;
  };
  return d;
}
var ca = (r) => (e) => la({
  theme: e,
  pseudos: Fr,
  configs: Dr
})(r);
function Ma(r) {
  return r;
}
function Fa(r) {
  return r;
}
function ua(r, e) {
  if (Array.isArray(r))
    return r;
  if (q(r))
    return e(r);
  if (r != null)
    return [r];
}
function pa(r, e) {
  for (let i = e + 1; i < r.length; i++)
    if (r[i] != null)
      return i;
  return -1;
}
function fa(r) {
  const e = r.__breakpoints;
  return function(s, d, c, p) {
    var u, m;
    if (!e)
      return;
    const f = {}, k = ua(c, e.toArrayValue);
    if (!k)
      return f;
    const z = k.length, y = z === 1, w = !!s.parts;
    for (let A = 0; A < z; A++) {
      const $ = e.details[A], B = e.details[pa(k, A)], C = Jn($.minW, B == null ? void 0 : B._minW), I = U((u = s[d]) == null ? void 0 : u[k[A]], p);
      if (I) {
        if (w) {
          (m = s.parts) == null || m.forEach((M) => {
            H(f, {
              [M]: y ? I[M] : { [C]: I[M] }
            });
          });
          continue;
        }
        if (!w) {
          y ? H(f, I) : f[C] = I;
          continue;
        }
        f[C] = I;
      }
    }
    return f;
  };
}
function Da(r) {
  return (e) => {
    var i;
    const { variant: s, size: d, theme: c } = e, p = fa(c);
    return H(
      {},
      U((i = r.baseStyle) != null ? i : {}, e),
      p(r, "sizes", d, e),
      p(r, "variants", s, e)
    );
  };
}
function Na(r) {
  return ra(r, ["styleConfig", "size", "variant", "colorScheme"]);
}
function Ga(r, e) {
  const i = {};
  return Object.keys(r).forEach((s) => {
    e.includes(s) || (i[s] = r[s]);
  }), i;
}
function ha(r, e, i, s) {
  const d = typeof e == "string" ? e.split(".") : [e];
  for (s = 0; s < d.length && r; s += 1)
    r = r[d[s]];
  return r === void 0 ? i : r;
}
var ga = (r) => {
  const e = /* @__PURE__ */ new WeakMap();
  return (s, d, c, p) => {
    if (typeof s > "u")
      return r(s, d, c);
    e.has(s) || e.set(s, /* @__PURE__ */ new Map());
    const u = e.get(s);
    if (u.has(d))
      return u.get(d);
    const m = r(s, d, c, p);
    return u.set(d, m), m;
  };
}, Ha = ga(ha);
function Bt(r, e) {
  const i = {};
  return Object.keys(r).forEach((s) => {
    const d = r[s];
    e(d, s, r) && (i[s] = d);
  }), i;
}
var ba = (r) => Bt(r, (e) => e != null);
function ma(r) {
  return typeof r == "function";
}
process.env.NODE_ENV;
process.env.NODE_ENV;
function va(r, ...e) {
  return ma(r) ? r(...e) : r;
}
function Va(...r) {
  return function(i) {
    r.some((s) => (s == null || s(i), i == null ? void 0 : i.defaultPrevented));
  };
}
var ya = /* @__PURE__ */ new Set([
  ...ta,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]), Sa = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function ka(r) {
  return Sa.has(r) || !ya.has(r);
}
function _a(r, ...e) {
  if (r == null)
    throw new TypeError("Cannot convert undefined or null to object");
  const i = { ...r };
  for (const s of e)
    if (s != null)
      for (const d in s)
        Object.prototype.hasOwnProperty.call(s, d) && (d in i && delete i[d], i[d] = s[d]);
  return i;
}
var kt, Ta = (kt = ht.default) != null ? kt : ht, xa = ({ baseStyle: r }) => (e) => {
  const { theme: i, css: s, __css: d, sx: c, ...p } = e, u = Bt(p, (z, y) => na(y)), m = va(r, e), f = _a(
    {},
    d,
    m,
    ba(u),
    c
  ), k = ca(f)(e.theme);
  return s ? [k, s] : k;
};
function zr(r, e) {
  const { baseStyle: i, ...s } = e ?? {};
  s.shouldForwardProp || (s.shouldForwardProp = ka);
  const d = xa({ baseStyle: i }), c = Ta(
    r,
    s
  )(d);
  return ft.forwardRef(function(m, f) {
    const { colorMode: k, forced: z } = gn();
    return ft.createElement(c, {
      ref: f,
      "data-theme": z ? k : void 0,
      ...m
    });
  });
}
function Ra() {
  const r = /* @__PURE__ */ new Map();
  return new Proxy(zr, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply(e, i, s) {
      return zr(...s);
    },
    /**
     * @example
     * <chakra.div />
     */
    get(e, i) {
      return r.has(i) || r.set(i, zr(i)), r.get(i);
    }
  });
}
var Ct = Ra();
function Nr(r) {
  return hn(r);
}
var It = Ct("div");
It.displayName = "Box";
var Et = Nr(function(e, i) {
  const { size: s, centerContent: d = !0, ...c } = e, p = d ? { display: "flex", alignItems: "center", justifyContent: "center" } : {};
  return /* @__PURE__ */ jr.jsx(
    It,
    {
      ref: i,
      boxSize: s,
      __css: {
        ...p,
        flexShrink: 0,
        flexGrow: 0
      },
      ...c
    }
  );
});
Et.displayName = "Square";
var wa = Nr(function(e, i) {
  const { size: s, ...d } = e;
  return /* @__PURE__ */ jr.jsx(Et, { size: s, ref: i, borderRadius: "9999px", ...d });
});
wa.displayName = "Circle";
var Ba = Nr(function(e, i) {
  const { direction: s, align: d, justify: c, wrap: p, basis: u, grow: m, shrink: f, ...k } = e, z = {
    display: "flex",
    flexDirection: s,
    alignItems: d,
    justifyContent: c,
    flexWrap: p,
    flexBasis: u,
    flexGrow: m,
    flexShrink: f
  };
  return /* @__PURE__ */ jr.jsx(Ct.div, { ref: i, __css: z, ...k });
});
Ba.displayName = "Flex";
export {
  It as B,
  Ba as F,
  Ct as a,
  H as b,
  Oa as c,
  ba as d,
  Ga as e,
  Nr as f,
  Pa as g,
  Wa as h,
  La as i,
  ja as j,
  Va as k,
  q as l,
  Ha as m,
  Fa as n,
  Na as o,
  Ma as p,
  Da as r,
  gn as u,
  Aa as w
};
